module.exports = __webpack_public_path__ + "img/team-member-04.b1b659b3.jpg";